import BenefitCard from "../BenefitCard/BenefitCard";

export default function BenefitsGrid({ cards }) {
  return (
    <div className="benefits-grid">
      {cards.map((item, index) => (
        <BenefitCard key={item.title} item={item} index={index} />
      ))}
    </div>
  );
}